import axios, { AxiosRequestHeaders, AxiosResponse } from 'axios';

import { captureException } from '../services/sentryService';

export default class GenericApiAdapter {
  private readonly headers: object;
  private readonly apiBaseUrl: string;
  public initialQueryParams: object = {};

  public constructor(apiBaseUrl: string, initialQueryParams: object = {}, headers: object = {}) {
    this.apiBaseUrl = apiBaseUrl;
    this.headers = headers;
    this.initialQueryParams = initialQueryParams;
  }

  private getHeaders(headers: object = {}): AxiosRequestHeaders {
    return {
      Accept: 'application/json',
      ...this.headers,
      ...headers,
    };
  }

  public async get<T>(url: string, headers: object = {}, queryParams?: object): Promise<T> {
    try {
      const result: AxiosResponse<T> = await axios({
        method: 'get',
        url: this.apiBaseUrl + encodeURI(url),
        headers: this.getHeaders(headers),
        params: queryParams,
      });

      if (!result) {
        throw new Error(`Internal error calling endpoint::: ${url}`);
      }
      return result.data;
    } catch (error) {
      throw captureException(error as Error);
    }
  }

  public async post<T>(url: string, body: RequestInit['body'], headers: object = {}): Promise<T> {
    try {
      const result: AxiosResponse<T> = await axios.post(this.apiBaseUrl + encodeURI(url), body, {
        headers: this.getHeaders(headers),
      });

      if (!result || !result.data) {
        throw new Error(`Internal error calling endpoint::: ${url}`);
      }

      return result.data;
    } catch (error) {
      throw captureException(error as Error);
    }
  }
}
